<template>
  <el-dialog
    :title="model.status == 1 ? '物流信息' : '上传发票'"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="发票" v-if="model.status == 2" prop="imgs">
        <upload v-model="model.imgs" :limit="1"></upload>
      </el-form-item>
      <el-form-item
        label="物流公司"
        prop="logistic_company"
        v-if="model.status == 1"
      >
        <ShipperSelect v-model="model.logistic_company"></ShipperSelect>
      </el-form-item>
      <el-form-item
        label="物流单号"
        prop="logistic_number"
        v-if="model.status == 1"
      >
        <el-input
          placeholder="物流单号"
          v-model="model.logistic_number"
        ></el-input>
      </el-form-item>

      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { saleOrderUpdateStatus } from '@/service/getData'
import upload from '../../../components/upload.vue'

import ShipperSelect from '@/components/select/shipper_select.vue'
export default {
  components: {
    upload,
    ShipperSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        logistic_company: [
          { required: true, message: '请选择物流公司', trigger: 'blur' },
        ],
        logistic_number: [
          { required: true, message: '请填写物流单号', trigger: 'blur' },
        ],
        imgs: [{ required: true, message: '请上传发票', trigger: 'change' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model

          if (data.imgs.length > 0) {
            data.receipt = {
              name: data.imgs[0].name,
              path: data.imgs[0].path,
            }
          }

          let res = await saleOrderUpdateStatus(data)
          if (res.code == 0) {
            this.$emit('callback', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>